import axios from 'axios'

const state = {
    list: [],
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
}

const options = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    }
}

const actions = {

    fetchDashboardData(context, payload) {
        return axios.post(process.env.VUE_APP_API_CLIENT_AREA_BASE_URL+'/fetch-dashboard-data', payload, options)
            .then((response) => {
                return response
            })
    },

    fetchUserPublicDocuments(context, payload) {
        return axios.post(process.env.VUE_APP_API_CLIENT_AREA_BASE_URL+'/fetch-user-public-documents', payload, options)
            .then((response) => {
                return response
            })
    },

    fetchGlobalDocuments(context, payload) {
        return axios.post(process.env.VUE_APP_API_CLIENT_AREA_BASE_URL+'/fetch-global-documents', payload, options)
            .then((response) => {
                return response
            })
    },

    fetchServices(context, payload) {
        return axios.post(process.env.VUE_APP_API_CLIENT_AREA_BASE_URL+'/fetch-services', payload, options)
            .then((response) => {
                return response
            })
    },

    generatePdf(context, payload) {
        return axios.post(process.env.VUE_APP_API_CLIENT_AREA_BASE_URL + '/' + payload.documentId + '/pdf', payload, options)
            .then((response) => {
                return response
            })
    },

    fetchInterventions(context, payload) {
        return axios.post(process.env.VUE_APP_API_CLIENT_AREA_BASE_URL + '/fetch-interventions', payload, options)
            .then((response) => {
                return response
            })
    },

    fetchTrends(context, payload) {
        return axios.post(process.env.VUE_APP_API_CLIENT_AREA_BASE_URL + '/fetch-trends', payload, options)
            .then((response) => {
                return response
            })
    },

    getTrendPdf(context, payload) {
        return axios.post(process.env.VUE_APP_API_CLIENT_AREA_BASE_URL + '/get-trend-pdf', payload, options)
            .then((response) => {
                return response
            })
    },


}

const getters = {
    list: state => state.list,
};

const clientArea = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default clientArea;
